<template>
  <div>
    <b-container>
      <Logs></Logs>
    </b-container>
  </div>
</template>

<script>
import Logs from '@/components/Logs.vue';
export default {
  name: 'logspage',
  components: {
    Logs
  }
}
</script>
